module.exports = __webpack_public_path__ + "img/readboylogo.7c334f92.png";